import { gql } from '@apollo/client'

export default gql`
  fragment progressInfo on Progress {
    total
    checked
  }
`
